import type { LessonMaterialFragment } from '../../../../shared/lesson-materials/lesson-material-fragment.generated';
import type { SearchMaterialsQuery } from './lesson-materials.graphql.generated';
import type { GetLessonTeachingAndLearningSequenceQuery } from '../teaching-notes.graphql.generated';
import type { Pluck } from 'lib/gql/pluck';

export function initialiseMaterials(
  note: Pluck<
    GetLessonTeachingAndLearningSequenceQuery,
    'getLessonTeachingAndLearningSequence'
  > | null
) {
  if (note?.lessonMaterials?.length === 1 && !note.lessonMaterials[0].name) {
    return [{ ...note.lessonMaterials[0], isEditMode: true }];
  }

  return (
    note?.lessonMaterials?.map(material => ({
      ...material,
      isEditMode: false,
    })) || []
  );
}

export type MaterialType =
  | Pluck<SearchMaterialsQuery, 'searchMaterials'>
  | Pluck<LessonMaterialFragment, 'alternativeMaterials'>;

export function filterOutSelectedMaterials<T extends MaterialType>(
  materials: T[],
  selectedMaterialIds: number[]
): T[] {
  return materials.filter(
    material => !selectedMaterialIds.find(id => id === material.id)
  );
}
